/**
 * @module app.ag
 * @preferred
 */

import { autoinject, PLATFORM } from 'aurelia-framework';
import { NavigationInstruction } from 'aurelia-router';
import { AppLogger } from 'app/shared/lib/logging/app-logger';
import { IAppRouteConfig } from 'app/shared/config/router-types';
import { AppModule, MemberFilters } from 'app/shared/config/modules';

@autoinject()
export class AppealsAndGrievancesManagementModule extends AppModule {

    public readonly code = 'ag';
    public readonly memberFilters = [];

    constructor(private readonly logger: AppLogger, memberFilters: MemberFilters) {
        super();

        logger.source = this;

        memberFilters.registerFilters(this.memberFilters);
    }

    public getTranslationNamespaces(): ReadonlyArray<string> {
        return ['ag'];
    }

    public getRoutes(): ReadonlyArray<IAppRouteConfig> {
        return [
            { route: 'ag/admin/user-defined-field/:userDefinedFieldDefinitionId', name: 'ag.admin.user-defined-field', navigationStrategy: instruction => this.navigateToUserDefinedFieldDefinition(instruction), settings: { topic: 'ag.admin.user-defined-field', bypassAuthentication: true } },
            { route: 'ag/admin/user-defined-fields', name: 'ag.admin.user-defined-fields', moduleId: PLATFORM.moduleName('app/ag/pages/admin/manage-user-defined-fields-page'), title: 'ag.admin.user-defined-fields', settings: { topic: 'ag.admin.user-defined-fields' } }
        ];
    }

    private async navigateToUserDefinedFieldDefinition(instruction: NavigationInstruction): Promise<void> {
        const { userDefinedFieldDefinitionId } = instruction.params;
        if(typeof userDefinedFieldDefinitionId === 'string') {
            try {
                instruction.config.moduleId = PLATFORM.moduleName(`app/ag/pages/admin/user-defined-field-page`);
                return;
            }
            catch(error) {
                this.logger.error(`Unable to navigate to User Defined Field Definition: ${userDefinedFieldDefinitionId}`);
            }
        }
        // redirect to not found page
        instruction.config.moduleId = PLATFORM.moduleName('app/shared/components/not-found');
    }
}
